import React from "react";

export const RobotFont = ({...props}) => {
  return <span style={{fontFamily:`roboto-${props.type}`}}>{`${props.children} `}</span>;
};
